// extracted by mini-css-extract-plugin
module.exports = {"post":"post_post__2uzyE","post--tiktok":"post_post--tiktok__26ew2","postContent":"post_postContent__czOVG","backgroundImage":"post_backgroundImage__JhRyu"};